import { Modal, Stack, Text } from '@mantine/core';

interface ScoutChatCloseConfirmModalProps {
  opened: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

export const ScoutChatCloseConfirmModal = ({
  opened,
  onClose,
  onConfirm,
}: ScoutChatCloseConfirmModalProps) => {
  return (
    <Modal opened={opened} onClose={onClose} title='Close Chat?' centered>
      <Stack gap='md'>
        <Text>Are you sure you want to close the chat?</Text>
        <div
          style={{
            display: 'flex',
            gap: 'var(--mantine-spacing-sm)',
            justifyContent: 'flex-end',
          }}
        >
          <button className='outline-button' onClick={onClose}>
            Cancel
          </button>
          <button className='primary-button' onClick={onConfirm}>
            Close Chat
          </button>
        </div>
      </Stack>
    </Modal>
  );
};

export default ScoutChatCloseConfirmModal;
